import { global } from ":shared/app";

const endpoint = "/workshops";

export type GET = {
  returns: {
    id: number;
    image: string;
    title: string;
    description: string;
    link: string;
    category: string;
    instructor: string;
    status: string;
    start: string;
    end: string;
    created_at?: string;
    update_at?: string;
  }[];
};
export async function get(): Promise<GET["returns"]> {
  // return Promise.resolve(import("./workshops.mocks")).then((r) => {
  //   return r.success;
  // });
  return global.api
    .getAuth(endpoint)
    .then((res) => {
      let res_list = res.data as GET["returns"];
      res_list = res_list.sort((a, b) => b.id - a.id);
      return Promise.resolve(res_list);
    })
    .catch((err) => {
      // message: service.api.decode_error(err, "couldn't update password"),
      return Promise.reject(err.message);
    });
}
